import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addSpecificFeedback, getfeedbackSpecific, saveSpecificFeedbacksToProd, deleteSpecificFeedback } from '../../actions';

import './feedback.css';

class Feedback extends Component {
  initState = { 
    specific: [],
    checked: [],
    show: false,
    oldName:null,
    specificSearch: '',
    _id: null,
    minor:'',
    text:'',
    speech: '',
    base: '',
    category:'',
    performence: ''
  }

  state = {
    specificAll: [],
    bases: ['POSITION', 'RANGE', 'PACE', 'OTHER','MODIFICATIONS'],
    categories: ['CORRECTIVE', 'PRAISE', 'ENCOURAGE', 'MOTIVATION', 'TIP', 'INSTRUCTIVE'],
    ...this.initState
  }

  componentWillMount = () => {
    this.props.getfeedbackSpecific();
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.deleteFeedbacks) {
      this.props.getfeedbackSpecific();
    } else if(nextProps.specific) {
      this.setState({
        specificAll: nextProps.specific,
        specific: nextProps.specific
      })
    }
  }

  handleChange = (evt) => {
    const value = evt.target.value;
    
    if(evt.target.name === 'minor' && this.state.oldName === null) {
      this.setState(prevState => {
        return {
          ...prevState,
          oldName: prevState.minor
        }
      })
    } else if(evt.target.name === 'specificSearch') {
      this.setState({
        specific: this.state.specificAll.filter(spec => spec.minor.toUpperCase().includes(value.toUpperCase()))
      })
    } 

    this.setState({
      [evt.target.name]: value
    });
  }

  renderSpecific = () => (
    this.state.specificAll ? 
    this.state.specificSearch === '' ?
      this.state.specificAll.sort((a,b) => (a.minor > b.minor) ? 1 : ((b.minor > a.minor) ? -1 : 0))
      .map((feedback, i) => {
        return <div key={i} style={{display: 'flex', width:'98%'}} onClick={()=> this.editFeedback(feedback)}> 
           <div className="column column-checkbox" style={{border: 'none'}}><input  className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={this.state.checked.indexOf(feedback._id) === -1 ? false : true }
          onChange={() => this.checkboxClick(feedback)}/></div>
          <div className="column hover"> {feedback.minor} </div>
          <div className="column"> {feedback.base || ""} </div>
          <div className="column"> {feedback.category || ""} </div>
        </div>
      }) 
      : 
      this.state.specific.sort((a,b) => (a.minor > b.minor) ? 1 : ((b.minor > a.minor) ? -1 : 0))
      .map((feedback, i) => {
        return <div key={i} style={{display: 'flex', width:'98%'}} onClick={()=> this.editFeedback(feedback)}> 
        <div className="column column-checkbox" style={{border: 'none'}}><input  className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={this.state.checked.indexOf(feedback._id) === -1 ? false : true }
          onChange={() => this.checkboxClick(feedback)}/></div>
          <div className="column hover"> {feedback.minor} </div>
          <div className="column"> {feedback.base || ""} </div>
          <div className="column"> {feedback.category || ""} </div>
        </div>
      }) 
    : null
  )

  showModal = () => {
    this.setState({show: true});
  }

  hideModal = () => {
    this.setState({
      ...this.initState
    });
  }

  submitForm = async (e) => {
    e.preventDefault();
    await this.props.addSpecificFeedback(this.state);

    this.setState({
      ...this.initState
    })
    this.props.getfeedbackSpecific();
  }

  editFeedback = (feedback) => {
    if (this.state.checked.length >= 1) {
      this.setState({_id: null,
        minor:'',
        text:'',
        speech: '',
        base: '',
        performence: '',
        category:''})
    } else {
      this.setState({
        _id: feedback._id,
        minor:feedback.minor,
        text:feedback.text,
        speech: feedback.speech,
        base: feedback.base,
        performence: feedback.performence ? feedback.performence : feedback.category && feedback.category === 'ENCOURAGE' ? -1 : 0,
        category: feedback.category ? feedback.category : feedback.performence && feedback.performence === -1 ? 'ENCOURAGE' : 'PRAISE'
      })
    }           
  }

  addNewFeedback = () => {
    this.setState({
      ...this.initState,
      show: true
    })
  }

  checkboxClick = (feedback) => {
    let index = this.state.checked.indexOf(feedback._id);
    if(index !== -1) {
      let checked = this.state.checked.filter(checkedW => checkedW !== feedback._id)
      
      this.setState({
        checked
      })
    } else {
      this.setState({
        checked: [...this.state.checked, feedback._id]
      })
    }
  }

  addToProduction = () => {
    let feedbacks = [];
    this.state.checked.forEach(id => {
      feedbacks.push(this.state.specificAll.find(feedback => feedback._id === id))
    })

    this.setState({
      ...this.initState
    })
    if(feedbacks.length > 0) {
      this.props.saveSpecificFeedbacksToProd(feedbacks);
    }
  }
  renderSelect = (options) => (
    options.map((lable, i) => {
      return <option key={i} value={lable}> {lable} </option>
    })
  )

  deleteFeedback = (e) => {
    e.preventDefault();
    this.props.deleteSpecificFeedback(this.state.checked);
    this.setState({...this.initState})
  }

  render() {
    return (
      <div>
      <div className="inline">
        <div className="specific-div">
          <h2>Specific</h2>
          <div className="inline">
          <div style={{display:"flex"}}>
            <input type="text" placeholder="Search"  name="specificSearch" value={this.state.specificSearch} onChange={this.handleChange} className="select-motivation search-input search-specific"/>
            <button onClick={this.deleteFeedback} className="addButton final-btn-feedback">Delete</button>
              {
                process.env.REACT_APP_ENVIRONMENT !== 'production'  ?
                  <button onClick={this.addToProduction} className="addButton final-btn final-btn-feedback">Add To Production</button>
                : null
              }
            </div>
          </div>
          <div className="specific-feedbacks-head ">
            <div className="column column-checkbox" style={{border: 'none'}} ></div>
            <div className="column column-head">Feedback Name</div>
            <div className="column column-head">Base</div>
            <div className="column column-head">Category</div>
          </div>
          <div className="specific-feedbacks">
            {this.renderSpecific()}
            {
              this.props.newFeedback && !this.props.newFeedback.success ? 
              <p className="error-message">Error Adding New Feedback - { this.props.newFeedback.message }</p> : 
              null
            }
          </div>     
        </div>
          <form onSubmit={this.submitForm} className="add-form"> 
              <div>
                <input 
                  name="minor"
                  type="text" 
                  className="input feedback-input"
                  placeholder="Name"
                  value={this.state.minor}
                  onChange={this.handleChange}
                />
              </div>
              <div style={{display: 'grid'}}>
                <input 
                    name="text"
                    type="text"
                    className="input input-motivation input-specific"
                    placeholder="Text"
                    value={this.state.text}
                    onChange={this.handleChange}
                />
                <input 
                    name="speech"
                    type="text"
                    className="input input-motivation input-specific"
                    placeholder="speech"
                    value={this.state.speech}
                    onChange={this.handleChange}
                />
                <select className="select-motivation input-motivation input-specific"  name="base" type="text" 
                  value={this.state.base} onChange={this.handleChange}>
                  <option>Select Base</option>
                  {this.renderSelect(this.state.bases)}
                </select>
                <select className="select-motivation input-motivation input-specific"  name="category" type="text" 
                  value={this.state.category} onChange={this.handleChange}>
                  <option>Select Category</option>
                  {this.renderSelect(this.state.categories)}
                </select>
              </div>
              <div style= {{display:'flex'}}>
              <button type="submit" className="savebtn" onClick={this.submitForm}>Save</button> 
                <button type="submit" className="savebtn" onClick={() => {this.setState({...this.initState})}}>Clear</button> 
              </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    specific: state.feedback.specific,
    newFeedback: state.feedback.newFeedback,
    deleteFeedbacks: state.feedback.deleteSpecificFeedback
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ addSpecificFeedback, getfeedbackSpecific, saveSpecificFeedbacksToProd, deleteSpecificFeedback },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);